import { CheckIcon } from '@phosphor-icons/react';
import { UserAvatar } from '@/components/NavigationBar/UserAvatar';

interface LogsUserFilterRowProps {
    name: string;
    email: string;
    isSelected: boolean;
}

export function LogsUserFilterRow({
    name,
    email,
    isSelected,
}: LogsUserFilterRowProps) {
    return (
        <span className="flex min-w-0 flex-1 items-center gap-2 py-1.5 pl-2 pr-1.5 text-white-100">
            {name && <UserAvatar name={name} size="xs" />}
            <span className="flex min-w-0 flex-1 flex-col">
                <span className="truncate text-sm leading-5">{name}</span>
                <span className="truncate text-xs text-grey-200">{email}</span>
            </span>
            {isSelected && <CheckIcon className="h-4 w-4 shrink-0" />}
        </span>
    );
}
